var map = {
	"./AirQuality.png": 459,
	"./Capacious.png": 18,
	"./CopOrNot.png": 416,
	"./ImageCompression.png": 363,
	"./JeanSizing.png": 444,
	"./JeanSizing2.png": 316,
	"./PersonalPortfolio.png": 622,
	"./SAIL.png": 979,
	"./ThreeTrios.png": 421,
	"./WordGame.png": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;